
export class AssessmentForMemberRequest
{
    public MemberCIN : string;
    public CalProviderId: string;
    public AssessmentTypeId : Number;
    public MeasurementPeriod : string;
}
